export default {
  首页: "首頁",
  资产: "資產",
  币币: "幣幣",
  快捷买币: "快捷買幣",
  "支持多种方式购买，购买更简单": "支持多種方式購買，購買更簡單",
  语言设置: "語言設置",
  确认恢复: "確認恢復",
  "输入邮箱，方便我们联系您": "輸入郵箱，方便我們聯繫您",
  划转: "劃轉",
  行情: "行情",
  "24H成交": "24H成交",
  累计收益: "累計收益",
  充值时间: "充值時間",
  到期时间: "到期時間",
  数量: "數量",
  操作: "操作",
  资产信息: "資產信息",
  复制地址: "複製地址",
  链名称: "鏈名稱",
  充值地址: "充值地址",
  收款地址: "收款地址",
  账单: "賬單",
  提现金额: "提現金額",
  接收地址: "接收地址",
  交易密码: "交易密碼",
  提现全部: "提現全部",
  保存图片: "保存圖片",
  输入您的交易密码: "輸入您的交易密碼",
  确定: "確定",
  地址: "地址",
  注册时间: "註冊時間",
  取消: "取消",
  是否划转: "是否劃轉",
  登录: "登錄",
  我的地址: "我的地址",
  登录密码和交易密码: "登錄密碼和交易密碼",
  注册: "註冊",
  密码: "密碼",
  设置密码: "設置密碼",
  重复密码: "重複密碼",
  新密码: "新密碼",
  确认新密码: "確認新密碼",
  充值: "充值",
  充值货币: "充值貨幣",
  合约账户充值: "合約賬戶充值",
  账户充值: "賬戶充值",
  其他: "其他",
  我的邀请码: "我的邀請碼",
  提现: "提現",
  客服: "客服",
  持有详情: "持有詳情",
  请输入内容: "請輸入內容",
  邀请好友来领取奖励: "邀請好友來領取獎勵",
  复制链接: "複製鏈接",
  重复设置新的密码: "重複設置新的密碼",
  保存: "保存",
  我的: "我的",
  "邮箱/手机号": "郵箱/手機號",
  备注: "備註",
  地址管理: "地址管理",
  我的团队: "我的團隊",
  联系我们: "聯繫我們",
  竭诚为您服务: "竭誠為您服務",
  提取收益: "提取收益",
  带给我的收益: "帶給我的收益",
  添加: "添加",
  名称: "名稱",
  添加地址: "添加地址",
  修改地址: "修改地址",
  可提现: "可提現",
  安全中心: "安全中心",
  收益划转: "收益劃轉",
  通知中心: "通知中心",
  "累计收益:": "累計收益:",
  注册用户: "註冊用戶",
  奖励规则: "獎勵規則",
  帮助反馈: "幫助反饋",
  邀请好友: "邀請好友",
  恢复身份: "恢復身份",
  选择语言: "選擇語言",
  设置新的密码: "設置新的密碼",
  暂无活动: "暫無活動",
  "月增长量(+)": "月增長量(+)",
  可提取: "可提取",
  反馈类型: "反饋類型",
  赠送: "贈送",
  已经复制: "已經復制",
  保存成功: "保存成功",
  划转成功: "劃轉成功",
  过期: "過期",
  提交成功: "提交成功",
  "服务器繁忙，稍后在试": "服務器繁忙，稍後在試",
  全部: "全部",
  一级: "一級",
  二级: "二級",
  三级: "三級",
  级: "級",
  删除成功: "刪除成功",
  选择地址: "選擇地址",
  不再提醒: "不再提醒",
  "最小充值金额：": "最小充值金額：",
  选择币种: "選擇幣種",
  输入投资金额: "輸入投資金額",
  输入账户密码: "輸入賬戶密碼",
  投资: "投資",
  订单编号: "訂單編號",
  投资周期: "投資週期",
  投资资金: "投資資金",
  投资时间: "投資時間",
  状态: "狀態",
  投资中: "投資中",
  已到期: "已到期",
  暂无数据: "暫無數據",
  转入: "轉入",
  邮箱: "郵箱",
  请输入邮箱: "請輸入郵箱",
  请输入格式正确的邮箱: "請輸入格式正確的郵箱",
  请输入验证码: "請輸入驗證碼",
  获取验证码: "獲取驗證碼",
  请输入邀请码: "請輸入邀請碼",
  今天: "今天",
  昨天: "昨天",
  最近七天: "最近七天",
  邀请: "邀請",
  购买数量: "購買數量",
  产品详情: "產品詳情",
  币种: "幣種",
  利息币种: "利息幣種",
  理财类型: "理財類型",
  产品费率: "產品費率",
  进行中: "進行中",
  每天: "每天",
  请输入搜索关键词: "請輸入搜索關鍵詞",
  通知: "通知",
  查看更多: "查看更多",
  理财宝: "理財寶",
  周期: "週期",
  年利率: "年利率",
  更多产品: "更多產品",
  灵活存取: "靈活存取",
  稳定收益: "穩定收益",
  合约指南: "合約指南",
  资金划转出: "資金劃轉出",
  矿池收益: "礦池收益",
  提现手续费: "提現手續費",
  冻结资金: "凍結資金",
  解冻资金: "解凍資金",
  闪兑支出: "閃兌支出",
  闪兑收入: "閃兌收入",
  闪兑手续费: "閃兌手續費",
  合约支出: "合約支出",
  合约收入: "合約收入",
  输入的金额不可大于可用金额: "輸入的金額不可大於可用金額",
  全部兑换成功: "全部兌換成功",
  返回: "返回",
  查看历史: "查看歷史",
  闪兑历史: "閃兌歷史",
  支付: "支付",
  获取: "獲取",
  时间: "時間",
  手续费: "手續費",
  折扣: "折扣",
  价格: "價格",
  逐仓: "逐倉",
  全仓: "全倉",
  市价委托: "市價委託",
  限价委托: "限價委託",
  请输入本金: "請輸入本金",
  请输入价格: "請輸入價格",
  "可做空/做多": "可做空/做多",
  设置止盈止损: "設置止盈止損",
  止盈价: "止盈價",
  止损价: "止損價",
  成本: "成本",
  做多: "做多",
  做空: "做空",
  仓位信息: "倉位信息",
  一键平仓: "一鍵平倉",
  永续: "永續",
  浮动盈亏: "浮動盈虧",
  平仓: "平倉",
  反向开仓: "反向開倉",
  一键撤销: "一鍵撤銷",
  倍杠杆: "倍槓桿",
  执行价格: "執行價格",
  委托数量: "委託數量",
  保证金: "保證金",
  成交价: "成交價",
  创建时间: "創建時間",
  撤销: "撤銷",
  合约市场: "合約市場",
  交易方向: "交易方向",
  委托价格: "委託價格",
  委托金额: "委託金額",
  资金费率: "資金費率",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "多方和空方交易者支付的定期費用，每8小時結算一次。",
  "资金费率为正，多方向空方支付资金费用。":
    "資金費率為正，多方向空方支付資金費用。",
  "资金费率为负，空方向多方支付资金费用。":
    "資金費率為負，空方向多方支付資金費用。",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "確定反向開倉嗎？反向開倉將以當期相反 的倉位進行買入",
  "仓位止盈/止损": "倉位止盈/止損",
  合约名称: "合約名稱",
  开仓价格: "開倉價格",
  指数价格: "指數價格",
  止盈设置: "止盈設置",
  请输入止盈价: "請輸入止盈價",
  "当指数价格触达*时，将会触发委托平仓":
    "當指數價格觸達{0}時，將會觸發委託平倉",
  预计盈亏: "預計盈虧",
  当前仓位: "當前倉位",
  平仓金额: "平倉金額",
  仓位模式: "倉位模式",
  全仓模式: "全倉模式",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "合約賬戶中的所有可用資金視作為可用保證金， 當倉位虧損超過了賬戶餘額才會爆倉強平，並將損失所有 保證金和倉位，請注意",
  逐仓模式: "逐倉模式",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "會使合約賬戶中的一定數量保證金被分配到倉位上。如果保證金虧損低於維持保證金的水平，倉位被強平。在逐倉模式下，您可以為這個倉位增加和減少保證金。",
  "是否撤销？": "是否撤銷？",
  "是否一键撤销？": "是否一鍵撤銷？",
  "是否一键平仓？": "是否一鍵平倉？",
  持仓保证金: "持倉保證金",
  风险率: "風險率",
  未实现盈亏: "未實現盈虧",
  可用保证金: "可用保證金",
  净值: "淨值",
  账户余额: "賬戶餘額",
  合约计算器: "合約計算器",
  交易记录: "交易記錄",
  "*倍杠杆": "{num}倍槓桿",
  "平仓盈亏：": "平倉盈虧：",
  时间筛选: "時間篩選",
  仓位类型: "倉位類型",
  订单状态: "訂單狀態",
  订单类型: "訂單類型",
  平仓价格: "平倉價格",
  持仓数量: "持倉數量",
  "手续费(%)": "手續費(%)",
  平仓时间: "平倉時間",
  平仓类型: "平倉類型",
  手动平仓: "手動平倉",
  强制平仓: "強制平倉",
  近1天: "近1天",
  近7天: "近7天",
  近30天: "近30天",
  近180天: "近180天",
  持仓: "持倉",
  已取消: "已取消",
  分时: "分時",
  "24H额(USDT)": "24H額(USDT)",
  "24H低": "24H低",
  "24H量(BTC)": "24H量(BTC)",
  "24H高": "24H高",
  "10秒": "10秒",
  "30秒": "30秒",
  "1分": "1分",
  "3分": "3分",
  "5分": "5分",
  "30分": "30分",
  "1小时": "1小時",
  "4小时": "4小時",
  "8小时": "8小時",
  "1天": "1天",
  "1周": "1週",
  "1月": "1月",
  单向持仓: "單向持倉",
  杠杆: "槓桿",
  仓位: "倉位",
  计算结果: "計算結果",
  盈亏: "盈虧",
  收益率: "收益率",
  计算结果仅供参考: "計算結果僅供參考",
  成交后仓位大小: "成交後倉位大小",
  "计算结果仅供参考,实际结果可能因费率差异":
    "計算結果僅供參考,實際結果可能因費率差異",
  目标价格: "目標價格",
  开始计算: "開始計算",
  强平价格: "強平價格",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "充值前，請認真核對充值的鏈名稱，充值錯誤無法找回資產{0}最小充值金額為{1}；少於此金額平台將無法確認到賬，請不要向此地址充值{2}之外的資產，否則將無法找回資產，請不要直接提現眾籌或者ICO地址，平台不會代理幣的發放。",
  "最小输入*": "最小輸入{0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "最小提幣數量為{0}，提幣手續費將從你的提款金額中扣除。提幣前請確認核對收款地址，不要將{1}提現至{2}以外的地址，否則無法找回資產。請不要直接提現眾籌或者ICO地址，平台不會處理代幣的發放。",
  退出登录: "退出登錄",
  加仓: "加倉",
  新增仓位: "新增倉位",
  输入加仓金额: "輸入加倉金額",
  "当前可用:": "當前可用:",
  资产账单: "資產賬單",
  保存二维码: "保存二維碼",
  温馨提示: "溫馨提示",
  "请注意：您当前使用的网络": "請注意：您當前使用的網絡",
  输入提现地址: "輸入提現地址",
  "可用金额：": "可用金額：",
  输入资产密码: "輸入資產密碼",
  可用手续费: "可用手續費",
  "折扣%": "折扣%",
  实扣手续费: "實扣手續費",
  实际到账: "實際到賬",
  未设置资产密码: "未設置資產密碼",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "為了您的資產安全，請設置資產密碼後再來提現。",
  热榜: "熱榜",
  涨幅榜: "漲幅榜",
  跌幅榜: "跌幅榜",
  成交额榜: "成交額榜",
  关于我们: "關於我們",
  登录密码: "登錄密碼",
  设置: "設置",
  资产密码: "資產密碼",
  修改登录密码: "修改登錄密碼",
  原密码: "原密碼",
  请输入新密码: "請輸入新密碼",
  请输入原密码: "請輸入原密碼",
  确认密码: "確認密碼",
  确定修改: "確定修改",
  修改资产密码: "修改資產密碼",
  验证码: "驗證碼",
  资产密码使用提示: "資產密碼使用提示",
  "资产密码用于转移、提取资产和交易。": "資產密碼用於轉移、提取資產和交易。",
  "创建与登录密码不同的资产密码。": "創建與登錄密碼不同的資產密碼。",
  "定期更改您的资产密码。": "定期更改您的資產密碼。",
  提币历史: "提幣歷史",
  "金额/余额": "金額/餘額",
  "手续费/折扣": "手續費/折扣",
  自选: "自選",
  现货: "現貨",
  市价: "市價",
  止损设置: "止損設置",
  合约K线图: "合約K線圖",
  "24H量": "24H量",
  "24H额": "24H額",
  合作指南: "合作指南",
  盈亏计算: "盈虧計算",
  当前可用: "當前可用",
  请输入加仓金额: "請輸入加倉金額",
  请重新输入加仓金额: "請重新輸入加倉金額",
  平仓数量: "平倉數量",
  欢迎登录: "歡迎登錄",
  "忘记密码?": "忘記密碼?",
  "还没有账号？": "還沒有賬號？",
  立即注册: "立即註冊",
  繁體中文: "繁體中文",
  找回密码: "找回密碼",
  下一步: "下一步",
  注册账户: "註冊賬戶",
  "请输入邀请码(选填)": "請輸入邀請碼(選填)",
  谢邀豪礼: "謝邀豪禮",
  "24小时邀请好友排名": "24小時邀請好友排名",
  "*人": "{0}人",
  "差*人": "差{0}人",
  "已超过10万人，每月轻松赚钱": "已超過10萬人，每月輕鬆賺錢",
  最高: "最高",
  邀请链接: "邀請鏈接",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "平台和您共享好友在平台（現貨、合約、槓桿、閃兌）所產生的手續費",
  平台和您一起分享手续费: "平台和您一起分享手續費",
  "*级": "{0}級",
  规则: "規則",
  我的好友: "我的好友",
  好友详情: "好友詳情",
  获得好友佣金方案: "獲得好友佣金方案",
  我的等级: "我的等級",
  我的邀请数据: "我的邀請數據",
  当前等级: "當前等級",
  平台奖励您: "平台獎勵您",
  最高可获取平台奖励: "最高可獲取平台獎勵",
  邀请规则: "邀請規則",
  "邀请*级有效好友": "邀請{0}級有效好友",
  好友等级: "好友等級",
  人: "人",
  奖金派送: "獎金派送",
  平台奖励: "平台獎勵",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "最終解釋權歸平台所有，若發現異常獲取平台獎勵，將會扣除所有的獎勵，並且凍結賬戶，資產的損失將無法找回。",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "您的賬戶必須是有效賬戶，平台判定有效賬戶條件為（賬戶充值任何幣種）最小{0} USDT的價值。",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "您邀請的好友，必須是有效下級，平台判定有效下級為（賬戶充值任何幣種）最小{0} USDT的價值。",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "邀請人和被邀請者的賬號不能同屬於一個IP。",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP等級由您邀請的{0}級好友的人數作為考核。",
  佣金成分: "佣金成分",
  收益统计: "收益統計",
  昨日收益: "昨日收益",
  月收益: "月收益",
  获取收益: "獲取收益",
  "总收益：": "總收益：",
  "*级好友": "{0}級好友",
  理财购买: "理財購買",
  期限: "期限",
  可用金额: "可用金額",
  预估收益: "預估收益",
  申购上限: "申購上限",
  项目剩余: "項目剩餘",
  "买入后预计*(SGT)开始计算收益。": "買入後預計{0}(SGT)開始計算收益。",
  计息日: "計息日",
  申购日: "申購日",
  到账日: "到賬日",
  到期自动续投: "到期自動續投",
  申购: "申購",
  搜索理财项目: "搜索理財項目",
  超高年化随心选: "超高年化隨心選",
  "自由选择理财币种，稳定超额收益": "自由選擇理財幣種，穩定超額收益",
  理财总资产: "理財總資產",
  累计收益: "累計收益",
  申购数量: "申購數量",
  立即购买: "立即購買",
  年化收益率: "年化收益率",
  理财订单: "理財訂單",
  持有: "持有",
  申购份额: "申購份額",
  到账日期: "到賬日期",
  申购成功: "申購成功",
  到期: "到期",
  是否选择做多: "是否選擇做多",
  "可用余额为0 不能操作": "可用餘額為0 不能操作",
  福利中心: "福利中心",
  奖励记录: "獎勵記錄",
  我获取到的奖励: "我獲取到的獎勵",
  总价值: "總價值",
  新手任务: "新手任務",
  身份认证: "身份認證",
  身份验证: "身份驗證",
  去验证: "去驗證",
  审核中: "審核中",
  已验证: "已驗證",
  认证失败: "認證失敗",
  基础认证: "基礎認證",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "請注意認證信息一經驗證不能修改，務必填寫準確信息",
  "国家/地区": "國家/地區",
  请选择: "請選擇",
  证件类型: "證件類型",
  证件编码: "證件編碼",
  身份证: "身份證",
  护照: "護照",
  驾驶证: "駕駛證",
  请输入编码: "請輸入編碼",
  名字: "名字",
  请输入: "請輸入",
  中间名: "中間名",
  选填: "選填",
  姓氏: "姓氏",
  中国: "中國",
  身份上传: "身份上傳",
  上传身份证: "上傳身份證",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "以上材料需要用JPG/JPEG/PNG格式上傳，並且保證照片的清晰邊角完整，亮度均勻。且大小不超過{0}M。",
  确定提交: "確定提交",
  去认证: "去認證",
  挑战任务: "挑戰任務",
  注册认证任务: "註冊認證任務",
  完成注册认证即可领取: "完成註冊認證即可領取",
  领取奖励: "領取獎勵",
  新人豪礼: "新人豪禮",
  "参与人数：": "參與人數：",
  条件: "條件",
  入金量: "入金量",
  完成: "完成",
  任务奖励: "任務獎勵",
  距任务更新: "距任務更新",
  "条件：": "條件：",
  活动规则: "活動規則",
  奖励明细: "獎勵明細",
  已获得: "已獲得",
  交易奖励: "交易獎勵",
  Win奖励: "Win獎勵",
  已领取: "已領取",
  亏损金额超过: "虧損金額超過",
  单笔开仓金额超过: "單筆開倉金額超過",
  交易量: "交易量",
  待完成: "待完成",
  入金: "入金",
  盈利金额超过: "盈利金額超過",
  开仓金额: "開倉金額",
  开仓金: "開倉金",
  盈利: "盈利",
  亏损: "虧損",
  领取: "領取",
  未领取: "未領取",
  待领取: "待領取",
  再交易: "再交易",
  即可获得: "即可獲得",
  领取成功: "領取成功",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1、所有的活動都會按照活動最後的時間進行統計收益過期後將無效。",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2、獲得的收益會發放到您的賞金賬戶中，你可以隨時根據您的需要進行兌換和提現。",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3、獲取的到的獎勵幣種類型根據任務按類型發放。",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4、最終解釋權歸平台所有，若發現存在異常手段套利平台的任務獎金，平台有權凍結並且清除您獲取的收益。",
  成长学院: "成長學院",
  "区块链 & 加密货币": "區塊鏈 & 加密貨幣",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "您的加密貨幣一站式指南，我們帶您開啟加密貨幣之路。",
  "全仓合约定单的全部保证金。": "全倉合約定單的全部保證金。",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(賬戶餘額+(浮動盈虧-手續費-過夜費)=淨值/已用保證金*100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "浮動盈虧會直接影響”可用保證金“，當未實現盈虧增加，可用保證金將會增加，未實現盈虧減少，可用保證金同樣也會減少。",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "賬戶餘額-(已用保證金)+(浮動盈虧-手續費-過夜費)",
  "注:可继续用于开仓的保证金。": "注:可繼續用於開倉的保證金。",
  "账户余额+(浮动盈亏-手续费-过夜费)": "賬戶餘額+(浮動盈虧-手續費-過夜費)",
  "注:当前的资金结余。": "注:當前的資金結餘。",
  "指的是合约账户的全部余额，包含不可用余额。":
    "指的是合約賬戶的全部餘額，包含不可用餘額。",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "注:風險率越高，風險越低，風險率越低，風險越高。",
  该功能尚未开发: "該功能尚未開發",
  重置密码: "重置密碼",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "請輸入為8-20位，必須包含字母、數字和特殊字符",
  修改成功: "修改成功",
  输入验证码: "輸入驗證碼",
  输入密码: "輸入密碼",
  详情说明: "詳情說明",
  已售罄: "已售罄",
  剩余期限: "剩餘期限",
  限期: "限期",
  闪兑货币选择: "閃兌貨幣選擇",
  地区选择: "地區選擇",
  "搜索国家/地区": "搜索國家/地區",
  "身份信息已提交，将在*小时内审核完成":
    "身份信息已提交，將在{0}小時內審核完成",
  "选择国家/地区": "選擇國家/地區",
  "止盈价格需高于*": "止盈價格需高於{0}",
  "止损价格需低于*": "止損價格需低於{0}",
  "止盈价格需低于*": "止盈價格需低於{0}",
  "止损价格需高于*": "止損價格需高於{0}",
  教程详情: "教程詳情",
  请输入止损价: "請輸入止損價",
  活期: "活期",
  赎回后立即到账: "贖回後立即到賬",
  赎回: "贖回",
  赎回理财: "贖回理財",
  是否赎回当前的理财订单: "是否贖回當前的理財訂單",
  维护: "維護",
  "系统正在维护中……": "系統正在維護中……",
  合约: "合約",
  闪电兑换: "閃電兌換",
  流水挖矿: "流水挖礦",
  邀请豪礼: "邀請豪禮",
  计算器: "計算器",
  最新价: "最新價",
  涨跌幅: "漲跌幅",
  关注币种添加自选: "關注幣種添加自選",
  一键添加自选: "一鍵添加自選",
  全标已读: "全標已讀",
  无消息: "無消息",
  "暂时还没有收到任何消息通知哦!": "暫時還沒有收到任何消息通知哦!",
  没有更多数据: "沒有更多數據",
  闪兑: "閃兌",
  从: "從",
  "可用余额：": "可用餘額：",
  至: "至",
  预览兑换结果: "預覽兌換結果",
  闪兑规则: "閃兌規則",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "市場閃兌可能變動，請以實際到賬的金額數量為準。",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "對匯兌率由第三方制定，由於兌換成本以及市場波動，您兌換的匯率可能會高於市場的匯率，請仔細確認後進行操作。",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "平台對每筆匯兌收取大約{fee}%的手續費，用於支付在交易所兌換成本。",
  确认汇兑: "確認匯兌",
  您预估得到: "您預估得到",
  汇兑: "匯兌",
  汇兑比例: "匯兌比例",
  刷新: "刷新",
  兑换: "兌換",
  没有更多了: "沒有更多了",
  搜索币种: "搜索幣種",
  可用: "可用",
  我知道了: "我知道了",
  最新价格: "最新價格",
  确认: "確認",
  最大: "最大",
  "风险率(%)": "風險率(%)",
  持仓: "持倉",
  当前委托: "當前委託",
  合作交易历史记录: "合作交易歷史記錄",
  重置: "重置",
  余额: "餘額",
  现货账户: "資金賬戶",
  合约账户: "合約賬戶",
  WIN账户: "WIN賬戶",
  赏金账户: "賞金賬戶",
  总资产折合: "總資產折合",
  今日收益: "今日收益",
  充币: "充幣",
  提币: "提幣",
  账户权益: "賬戶權益",
  "数量/类别": "數量/類別",
  全部币种: "全部幣種",
  全部类型: "全部類型",
  账单信息: "賬單信息",
  理财赎回: "理財贖回",
  购买理财: "購買理財",
  收入: "收入",
  支出: "支出",
  到: "到",
  资产划转: "資產劃轉",
  "最少*": "最少*",
  "可用资产：": "可用資產：",
  确认划转: "確認劃轉",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "只有將資產劃轉至對於的賬戶才可以進行交易，賬戶間的劃轉不收取手續費。",
  币种账户选择: "幣種賬戶選擇",
  选择账户: "選擇賬戶",
  划转详情: "劃轉詳情",
  划转明细: "劃轉明細",
  收入账单: "收入賬單",
  支出账单: "支出賬單",
  金额: "金額",
  总收益: "總收益",
  佣金: "佣金",
  用户名: "用戶名",
  "已领取：": "已領取：",
  "未领取：": "未領取：",
  "请选择国家/地区": "請選擇國家/地區",
  请上传身份信息: "請上傳身份信息",
  请选择证件类型: "請選擇證件類型",
  请填写证件编码: "請填寫證件編碼",
  请填写名字: "請填寫名字",
  请填写姓氏: "請填寫姓氏",
  单向持仓: "單向持倉",
  投资金额: "投資金額",
  天: "天",
  请输入手机号: "請輸入手機號",
  搜索: "搜索",
  搜索历史: "搜索歷史",
  热门推荐: "熱門推薦",
  "《Xspace Earn协议》": "《Xspace Earn協議》",
  我已了解并同意: "我已了解並同意",
  协议: "協議",
  Xspace官方中文交流群: "Xspace官方中文交流群",
  Xspace官方英文交流群: "Xspace官方英文交流群",
  预计维护至: "預計維護至",
  更多功能: "更多功能",
  下载APP: "下載APP",
  理财: "理財",
  推荐: "推薦",
  Telegram官方中文频道: "Telegram官方中文頻道",
  Telegram官方英文频道: "Telegram官方英文頻道",
  官方邮箱: "官方郵箱",
  客服邮箱: "客服郵箱",
  上述信息最终解释权归官方所有: "上述信息最終解釋權歸官方所有",
  IOS版下载: "IOS版下載",
  Android版下载: "Android版下載",
  "手续费=买入手续费+资金费率+卖出手续费":
    "手續費 = 買入手續費 + 資金費率 + 賣出手續費",
  资金划转: "資金劃轉",
  止盈: "止盈",
  止损: "止損",
  自动平仓: "自動平倉",
  委托挂单: "委託掛單",
  买: "買",
  卖: "賣",
  "买入/做多": "買入/做多",
  "卖出/做空": "賣出/做空",
  详情: "詳情",
  浮动涨跌: "浮動漲跌",
  最小: "最小",
  充币数量: "充幣數量",
  请输入充币数量: "請輸入充幣數量",
  支付截图: "支付截圖",
  提交: "提交",
  上传驾驶证: "上傳駕駛證",
  上传护照: "上傳護照",
  加载中: "加載中",
  上传成功: "上傳成功",
  充值历史: "充值歷史",
  合约卖出手续费: "合約賣出手續費",
  合约买入手续费: "合約買入手續費",
  系统加款: "系統加款",
  系统减款: "系統減款",
  合约资金费率: "合約資金費率",
  佣金分成: "佣金分成",
  U本位合约: "U本位合約",
  资产管理: "資產管理",
  APP下载: "APP下載",
  全球领先的数字理财平台: "全球領先的數字理財平台",
  "即刻交易比特币、以太坊等上百种数字资产":
    "即刻交易比特幣、以太坊等上百種數字資產",
  "24H涨跌幅": "24H漲跌幅",
  查看更多行情: "查看更多行情",
  近24小时成交量: "近24小時成交量",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "提供數百種幣幣和合約交易對，以滿足多樣化的交易需求。平台在200個國家和地區中有超過2千萬用戶，是全球領先的數字資產服務平台。",
  用户国家分布: "用戶國家分佈",
  用户数: "用戶數",
  交易对: "交易對",
  服务支持: "服務支持",
  "随时随地，多平台终端交易": "隨時隨地，多平台終端交易",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "多終端完美兼容，隨時滿足各種場景的交易需求。",
  随时查看实时行情: "隨時查看實時行情",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "輕鬆買賣BTC，ETH，DOGE和其他數字資產",
  获取您关注的加密货币价格变化预警: "獲取您關注的加密貨幣價格變化預警",
  "查看比特币现货、期货、期权价格": "查看比特幣現貨、期貨、期權價格",
  比较各交易所加密货币价格: "比較各交易所加密貨幣價格",
  开启您的数字货币之旅: "開啟您的數字貨幣之旅",
  快捷购买数字货币: "快捷購買數字貨幣",
  "使用多种支付方式交易数字货币，安全快捷":
    "使用多種支付方式交易數字貨幣，安全快捷",
  最优的交易费率: "最優的交易費率",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "優惠的交易費率，富有競爭力的VIP權益，享受最優品質的服務",
  可信赖的安全保障: "可信赖的安全保障",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "我們複雜的安全措施和SAFU基金保護您的數字資產免受所有風險。",
  交易: "交易",
  币币市场: "幣幣市場",
  "24H成交量": "24H成交量",
  交易所: "交易所",
  "24H最高": "24H最高",
  "24H最低": "24H最低",
  永续合约: "永續合約",
  日涨跌: "日漲跌",
  交易深度: "交易深度",
  "资产(合约)": "資產(合約)",
  历史仓位: "歷史倉位",
  兑换记录: "兌換記錄",
  类型: "類型",
  充值记录: "充值記錄",
  划转记录: "劃轉記錄",
  类别: "類別",
  历史账单: "歷史賬單",
  在线充值: "在線充值",
  安全设置: "安全設置",
  用于账户登录使用: "用於賬戶登錄使用",
  用户提现时安全验证使用: "用戶提現時安全驗證使用",
  验证: "驗證",
  万: "萬",
  随时随地开启交易: "隨時隨地開啟交易",
  "*货币交易所的所有功能尽在你的手中。":
    "{0}貨幣交易所的所有功能盡在你的手中。",
  "下载*货币交易所APP。": "下載{0}貨幣交易所APP。",
  下载自: "下載自",
  内测版: "內測版",
  下载: "下載",
  扫码下载: "掃碼下載",
  设置您的资产密码: "設置您的資產密碼",
  法币: "法幣",
  我要买: "我要買",
  我要卖: "我要賣",
  请输入金额: "請輸入金額",
  汇率: "匯率",
  获得: "獲得",
  支付通道: "支付通道",
  收款通道: "收款通道",
  "出售过程需要务必确认好您的收款方式为本人。":
    "出售過程需要務必確認好您的收款方式為本人。",
  当前法币暂不支持交易对可尝试前往提现: "當前法幣暫不支持交易對可嘗試前往提現",
  前往提现: "前往提現",
  该法币暂无通道: "該法幣暫無通道",
  "正在出售中，请耐心等待": "正在出售中，請耐心等待",
  请选择支付通道: "請選擇支付通道",
  请选择方式: "請選擇方式",
  法币历史: "法幣歷史",
  买币: "買幣",
  卖币: "賣幣",
  失败: "失敗",
  已完成: "已完成",
  未付款: "未付款",
  待审核: "待審核",
  打款中: "打款中",
  订单详情: "訂單詳情",
  联系客服: "聯繫客服",
  到账金额: "到賬金額",
  通道: "通道",
  收款人: "收款人",
  收款账户: "收款賬戶",
  "订单出售失败，请查下方失败原因": "訂單出售失敗，請查下方失敗原因",
  失败原因: "失敗原因",
  您还未进行付款: "您還未進行付款",
  您已成功购买: "您已成功購買",
  已取消订单: "已取消訂單",
  "订单正在审核中，请耐心等待": "訂單正在審核中，請耐心等待",
  您已成功出售: "您已成功出售",
  "订单正在打款中，请耐心等待": "訂單正在打款中，請耐心等待",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "支付過程需要您前往其他的平台進行支付訂單，請注意信息安全。",
  当前法币暂不支持交易对可尝试前往充值: "當前法幣暫不支持交易對可嘗試前往充值",
  前往充值: "前往充值",
  购买: "購買",
  订单号: "訂單號",
  单价: "單價",
  到账数量: "到賬數量",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "當前存在未付的訂單，是否繼續發起新的支付訂單？",
  继续支付: "繼續支付",
  重新下单: "重新下單",
  是否确定出售: "是否確定出售",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "確定出售後，平台將分配給買家，請耐心等待平台的撮合。",
  出售: "出售",
  收款方式: "收款方式",
  订单已生成: "訂單已生成",
  取消订单: "取消訂單",
  请在: "請在",
  内完成付款: "內完成付款",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "離開平台，登錄您指定的支付，轉賬到賣家的以下賬戶，並務必在付款中備註：",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "若付款時未進行備註，賣家將無法確認收款，造成資產損失無法找回。",
  "未在规定的时间内付款，订单都将被取消。":
    "未在規定的時間內付款，訂單都將被取消。",
  姓名: "姓名",
  收款姓名: "收款姓名",
  开户支行: "開戶支行",
  银行卡号: "銀行卡號",
  "付款后，返回本平台": "付款後，返回本平台",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "請務必點擊下方“我已完成付款，通知賣家”按鈕",
  未点击卖家不会放款: "未點擊賣家不會放款",
  交易条款: "交易條款",
  "购买资金来源，必须合法安全的资金，方可交易":
    "購買資金來源，必須合法安全的資金，方可交易",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "不允許詐騙、傳銷、賭博或者其他非法資金交易",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "交易完成後，出現資金風險，被凍結或者涉嫌欺詐、傳銷、賭博的資金，我方將不在向買方放U，並給予退款",
  "已付款，通知卖家": "已付款，通知賣家",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "買方當日累計取消{0}筆訂單，將會取消當日購買功能。確定取消該訂單嗎？",
  添加收款方式: "添加收款方式",
  是否删除此收款方式: "是否刪除此收款方式",
  删除: "刪除",
  请选择法币: "請選擇法幣",
  机构名称: "機構名稱",
  请选择机构: "請選擇機構",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "當您出售數字貨幣時，您選擇的收款方式將向買方展示，請確認填寫無誤。",
  请选择银行: "請選擇銀行",
  请输入姓名: "請輸入姓名",
  账号: "賬號",
  请输入账号: "請輸入賬號",
  收款码: "收款碼",
  "银行账号/卡号": "銀行賬號/卡號",
  "请输入银行账号/卡号": "請輸入銀行賬號/卡號",
  "开户支行（选填）": "開戶支行（選填）",
  请输入开户支行: "請輸入開戶支行",
  "加入*官方频道": "加入{0}官方頻道",
  关于: "關於",
  条款: "條款",
  其他: "其他",
  成功: "成功",
  等待: "等待",
  作废: "作廢",
  确认付款: "確認付款",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "是否已完成付款？若確認付款後，商家將會在{0}分內進行確認是否收到付款。",
  最大金额: "最大金額",
  最小金额: "最小金額",
  付款: "付款",
  法币充值: "法幣充值",
  法币提现: "法幣提現",
  待支付: "待支付",
  已支付: "已支付",
  商户名: "商戶名",
  当前没有添加支付方式: "當前沒有添加支付方式",
  添加后再出售: "添加後再出售",
  新人大礼包: "新人大禮包",
  注册即可领取: "註冊即可領取",
  立即领取: "立即領取",
  不再提示: "不再提示",
  "该奖励需在APP中领取，请下载APP": "該獎勵需在APP中領取，請下載APP",
  去交易: "去交易",
  期权交易: "期權交易",
  交易额: "交易額",
  可用额度: "可用額度",
  交易周期: "交易週期",
  看涨: "看漲",
  看跌: "看跌",
  当前持有: "當前持有",
  胜率: "勝率",
  "盈利/亏损数": "盈利/虧損數",
  累计实现盈亏: "累計實現盈虧",
  秒: "秒",
  分: "分",
  小时: "小時",
  天: "天",
  周: "週",
  下单时间: "下單時間",
  剩余时间: "剩餘時間",
  买入价: "買入價",
  结算价: "結算價",
  实现盈利: "實現盈利",
  结算时间: "結算時間",
  期权: "期權",
  新手教程: "新手教程",
  我的订单: "我的訂單",
  赔率: "賠率",
  全部订单: "全部訂單",
  持有订单: "持有訂單",
  历史订单: "歷史訂單",
  输入交易额度: "輸入交易額度",
  选择交易周期: "選擇交易週期",
  去注册: "去註冊",
  冻结: "凍結",
  "是否购买？": "是否購買？",
  购买成功: "購買成功",
  余额不足: "餘額不足",
  最低购买: "最低購買",
  最高购买: "最高購買",
  下单成功: "下單成功",
  平仓成功: "平倉成功",
  请输入正确的平仓数量: "請輸入正確的平倉數量",
  加仓成功: "加倉成功",
  请输入正确的加仓金额: "請輸入正確的加倉金額",
  收藏成功: "收藏成功",
  取消收藏成功: "取消收藏成功",
  请签名: "請簽名",
  提交签名: "提交簽名",
  清空签名: "清空簽名",
  签名审核中: "簽名審核中",
  已提交: "已提交",
  扫一扫下载APP: "掃一掃下載APP",
  新手领取大礼包: "新手領取大禮包",
  注册实名即送彩金: "註冊實名即送彩金",
  交易总额: "交易總額",
  资产不足: "資產不足",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Win賬戶的資產不足，可從資金賬戶劃轉至此賬戶",
  Win: "Win",
  在线充值: "在線充值",
  比赛: "比賽",
  未开始: "未開始",
  赛程: "賽程",
  赛果: "賽果",
  已结束: "已結束",
  让球: "讓球",
  进球数: "進球數",
  大: "大",
  小: "小",
  胜负平: "勝負平",
  和局: "和局",
  投注: "投注",
  下注金额: "下注金額",
  下注: "下注",
  阵容: "陣容",
  分析: "分析",
  输入下注金额: "輸入下注金額",
  下注成功: "下注成功",
  投注记录: "投註記錄",
  未结算: "未結算",
  已结算: "已結算",
  流水: "流水",
  输赢: "輸贏",
  赛时: "賽時",
  下注时间: "下注時間",
  足彩竞猜: "足彩競猜",
  查看详情: "查看詳情",
  输: "輸",
  赢: "贏",
  主: "主",
  客: "客",
  主胜: "主勝",
  客胜: "客勝",
  平: "平",
  已延期: "已延期",
  账号异常: "賬號異常",
  全场独赢: "全場獨贏",
  全场让球: "全場讓球",
  全场大小: "全場大小",
  总进球: "總進球",
  拍摄照片要求: "拍攝照片要求",
  标准拍摄: "標準拍攝",
  边框缺失: "邊框缺失",
  照片模糊: "照片模糊",
  闪光强烈: "閃光強烈",
  上传手持证件照: "上傳手持證件照",
  上传证件照: "上傳證件照",
  换一张: "換一張",
  出生日期: "出生日期",
  请选择出生日期: "請選擇出生日期",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "輸入下方正確的圖形驗證後，獲取郵箱驗證碼進行註冊",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "您還剩餘{0}次認證次數，超出次數將無法繼續認證",
  上半场: "上半場",
  下半场: "下半場",
  独赢: "獨贏",
  上半场独赢: "上半場獨贏",
  下半场独赢: "下半場獨贏",
  上半场让球: "上半場讓球",
  下半场让球: "下半場讓球",
  上半场大小球: "上半場大小球",
  下半场大小球: "下半場大小球",
  波胆: "波膽",
  上半场波胆: "上半場波膽",
  下半场波胆: "下半場波膽",
  单双: "單雙",
  单: "單",
  双: "雙",
  上半场单双: "上半場單雙",
  下半场单双: "下半場單雙",
  总进球: "總進球",
  上半场总进球: "上半場總進球",
  下半场总进球: "下半場總進球",
  中场: "中場",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "注意：手持證件照請按照此示例圖在白紙上書寫文字並與證件一起拍攝",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "近期發現大量作弊賬戶，對一批違規賬戶進行了懲罰。如果有誤判為違規賬戶，請聯繫在線客服。",
  最小下注金额: "最小下注金額",
  参与活动最小下注金额: "參與活動最小下注金額",
  记住密码: "記住密碼",
  比分: "比分",
  "您还未登录，请先登录": "您還未登錄，請先登錄",
  立即登录: "立即登錄",
  下注限额: "下注限額",
  可赢金额: "可贏金額",
  闪兑详情: "閃兌詳情",
  大小球: "大小球",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "由於匯率原因，下注金額和實際下注金額會有誤差，請以訂單為準。",
  开赛时间: "開賽時間",
  足球收入: "足球收入",
  足球支出: "足球支出",
  活动详情: "活動詳情",
  为世界杯喝彩: "為世界杯喝彩",
  我的竞猜: "我的競猜",
  "竞猜比赛、有机会瓜分*USDT": "競猜比賽、有機會瓜分{0}USDT",
  "瓜分*USDT": "瓜分{0}USDT",
  距离活动结束还有: "距離活動結束還有",
  我的门票: "我的門票",
  竞猜结束时间: "競猜結束時間",
  猜比分: "猜比分",
  "福利派送中，完成任务即可获取门票": "福利派送中，完成任務即可獲取門票",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "完成如下任務，可獲對應數量門票的參與競賽",
  时: "時",
  活动: "活動",
  竞猜记录: "競猜記錄",
  结果: "結果",
  任务: "任務",
  去邀请: "去邀請",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "每場比賽的比分競猜，參與競猜可瓜分${0}美金的獎勵。",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "參與競猜需要門票，門票可按照平台的任務進行獲得。",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "競猜成功後，把競猜結果的截圖發送給客服，客服會把獎金劃入您的資金賬戶，你可以立即提取。",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "禁止任何作弊行為、如果發現作弊行為，獎勵無效。",
  "完成任务后，点击咨询客服获得门票。": "完成任務後，點擊諮詢客服獲得門票。",
  继续猜: "繼續猜",
  总单数: "總單數",
  赛事筛选: "賽事篩選",
  球队筛选: "球隊篩選",
  总金额: "總金額",
  总流水: "總流水",
  派奖金额: "派獎金額",
  下注单数: "下注單數",
  利润: "利潤",
  更多福利: "更多福利",
  我的奖金: "我的獎金",
  未认证: "未認證",
  总量: "總量",
  或: "或",
  模拟交易: "模擬交易",
  体验账户不可操作: "體驗賬戶不可操作",
  世界杯比分竞猜: "世界杯比分競猜",
  "领*USDT起": "領{0}USDT起",
  消息: "消息",
  滚球: "滾球",
  是: "是",
  不是: "不是",
  当前余额: "當前餘額",
  KOL招募: "KOL招募",
  本月净输赢: "本月淨輸贏",
  本月佣金: "本月傭金",
  佣金比例: "傭金比例",
  活跃人数: "活躍人數",
  新增下级: "新增下級",
  登录人数: "登入人數",
  首存人数: "首存人數",
  数据分析: "資料分析",
  人数: "人數",
  新注册存款金额: "新注册存款金額",
  老用户存款金额: "老用戶存款金額",
  首存金额: "首存金額",
  快捷入口: "快捷入口",
  成员管理: "成員管理",
  财务报表: "財務報表",
  分红报表: "分紅報表",
  订单记录: "訂單記錄",
  VIP专享: "VIP專享",
  推广工具: "推廣工具",
  计算规则: "計算規則",
  账变明细: "賬變明細",
  成员: "成員",
  下级概览: "下級概覽",
  下级成员总计: "下級成員總計",
  本月新增: "本月新增",
  本月活跃会员: "本月活躍會員",
  今日活跃会员: "今日活躍會員",
  本月有效活跃: "本月有效活躍",
  活跃成员占比: "活躍成員占比",
  本月活跃: "本月活躍",
  今日活跃: "今日活躍",
  下级成员: "下級成員",
  会员账号: "會員帳號",
  统计时间: "統計時間",
  筛选: "篩選",
  存款: "存款",
  取款: "取款",
  总输赢: "總輸贏",
  是否有效用户: "是否有效用戶",
  最近登录时间: "最近登入時間",
  否: "否",
  开始时间: "開始時間",
  结束时间: "結束時間",
  提取: "提取",
  总盈亏: "總盈虧",
  净盈亏: "淨盈虧",
  分红: "分紅",
  概览: "概覽",
  月度详细数据: "月度詳細數據",
  未发放: "未發放",
  活跃用户: "活躍用戶",
  有效新增会员: "有效新增會員",
  冲正后净输赢: "沖正後淨輸贏",
  上月结余: "上月結餘",
  净输赢: "淨輸贏",
  "系统每日新加坡时间1:00更新一次报表": "系統每日新加坡時間1:00更新一次報表",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "報表中數據、總輸贏、淨輸贏中正數表示代理方盈利、負數表示代理方虧損",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "傭金數據每天進行更新，僅供參考，並不做實際傭金派發標準",
  选择时间: "選擇時間",
  足球: "足球",
  投注金额: "投注金額",
  有效订单: "有效訂單",
  下级账户: "下級帳戶",
  待成交: "待成交",
  下单金额: "下單金額",
  订单内容: "訂單內容",
  秒数: "秒數",
  联赛: "聯賽",
  队伍: "隊伍",
  比赛时间: "比賽時間",
  玩法: "玩法",
  等级规则表: "等級規則錶",
  等级: "等級",
  活跃会员: "活躍會員",
  最新活跃: "最新活躍",
  额外佣金: "額外傭金",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "每月按照對應等級的增長標準與獎勵制度執行，只可享受一個等級獎勵。",
  渠道生成: "通路生成",
  创建: "創建",
  渠道名称: "通路名稱",
  注册人数: "注册人數",
  浏览人数: "流覽人數",
  构建状态: "構建狀態",
  禁用: "禁用",
  启用: "啟用",
  查看: "查看",
  创建渠道: "創建通路",
  创建成功: "創建成功",
  操作成功: "操作成功",
  渠道详情: "通路詳情",
  邀请码: "邀請碼",
  访问人数: "訪問人數",
  渠道地址: "通路地址",
  我的福利: "我的福利",
  充值福利: "充值福利",
  当前流水: "當前流水",
  如何参与: "如何參與",
  币种充值: "幣種充值",
  充值福利中领取福利: "充值福利中領取福利",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "規則：充值福利自願領取，有效期為充值後的24小時內，過期無效，領取後將暫時鎖定提現功能，當流水達到後即可解鎖提現。",
  失效日期: "失效日期",
  "暂无福利领取，充值后领取": "暫無福利領取，充值後領取",
  参与: "參與",
  充值赠送: "充值贈送",
  "领取*%的赠送": "領取{0}%的贈送",
  去领取: "去領取",
  VIP奖励: "VIP獎勵",
  "当前可领取*USDT，是否确认领取": "當前可領取{0}USDT，是否確認領取",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "領取後將臨時鎖定提現功能，當您的流水到達{0}USDT後即可解除鎖定",
  充值送大礼: "充值送大禮",
  "存入越多，送越多！": "存入越多，送越多！",
  无效: "無效",
  有效: "有效",
  总存金额: "總存金額",
  提示: "提示",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "總輸贏，淨輸贏中正數表示平臺盈利，負數表示虧損，每天數據只做參攷，並不做實際傭金派發標準。",
  "净盈亏：总盈亏-用户返水": "淨盈虧：總盈虧-用戶返水",
  盈利方: "盈利方",
  代理: "代理",
  客户: "客戶",
  平局: "平局",
  平台: "平臺",
  "已提交审核，请耐心等待": "已提交稽核，請耐心等待",
  充值日期: "充值日期",
  平台本月总输赢: "平臺本月總輸贏",
  KOL招募合作: "KOL招募合作",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "平臺現在開放【KOL招募活動】，只要您有社群媒體號，就可以和平臺享受分紅一次性推廣客戶，就可以享受終生收益。",
  级别: "級別",
  平台利润返佣: "平臺利潤返傭",
  佣金案例: "傭金案例",
  交易项目: "交易項目",
  "期权交易、合约交易、足球游戏": "期權交易、合約交易、足球遊戲",
  报名方式: "報名方式",
  点击KOL招募报名: "點擊KOL招募報名",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "歡迎加入我們的團隊，平臺全面扶持您建立屬於自己的用戶體系，最高可得{0}的傭金，我們期待您加入。",
  输入联系方式: "輸入聯繫方式",
  最低活跃人数: "最低活躍人數",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "如：本月活躍人數≥{0}並且本月平臺總輸贏≥{1}USDT，您屬於等級{2}，即可得到{3}%的傭金。",
  比分竞猜: "比分競猜",
  豪礼相赠: "豪禮相贈",
  足球活动: "足球活動",
  圣诞节活动: "耶誕節活動",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "您參加了活動，臨時鎖定提現功能，還需{0}USDT流水就可以解除鎖定。",
  剩余流水: "剩餘流水",
  助力足球: "助力足球",
  佣金累计: "佣金累計",
  有效投注: "有效投注",
  今日: "今日",
  今日返水: "今日返水",
  VIP返水: "VIP返水",
  返水记录: "返水記錄",
  成员信息: "成員信息",
  基本信息: "基本信息",
  钱包余额: "錢包餘額",
  投注信息: "投注信息",
  返水: "返水",
  总下注: "總下注",
  今日输赢: "今日輸贏",
  下注动态: "下注動態",
  返水奖励: "返水獎勵",
  分红金额: "分紅金額",
  返水支出: "返水支出",
  总返水: "總返水",
  流水总额: "流水總額",
  返水总额: "返水總額",
  返水详情: "返水詳情",
  日流水: "日流水",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "平台根據你下級每日流水進行額外返水獎勵,獎勵每日新加坡時間00：00進行派發至賞金賬戶",
  "申请成功，等待审核": "申請成功，等待審核",
  "我出本金，盈利共分享": "我出本金，盈利共分享",
  最高分红: "最高分紅",
  投资大师比赛: "投資大師比賽",
  "我出本金，你盈利": "我出本金，你盈利",
  共分享: "共分享",
  最高分红可得: "最高分紅可得",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "新用戶專屬福利來襲，免費贈送${0}，領取後即可投資平台任何項目，盈利後立即可提取。",
  报名领取: "報名領取",
  已领取: "已領取",
  审核驳回: "審核駁回",
  驳回原因: "駁回原因",
  活动运行周期: "活動運行週期",
  "申请成功后起至*天内完成超额收益。": "申請成功後起至{0}天內完成超額收益。",
  分红比: "分紅比",
  "*日获得盈利后，可获得*%的收益额。": "{0}日獲得盈利後，可獲得{1}%的收益額。",
  参与条件: "參與條件",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "俄羅斯、土耳其地區的用戶，且未參與。",
  计算项目: "計算項目",
  "合约、体育、期权": "合約、體育、期權",
  我的投资: "我的投資",
  参与天数: "參與天數",
  累计下注: "累計下注",
  累计盈亏: "累計盈虧",
  预计可分红: "預計可分紅",
  常见问题: "常見問題",
  什么是平台出资: "什麼是平台出資",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "平台根據部分國家的用戶，免費提供資金讓用戶去投項目。",
  怎么获取平台出资的福利: "怎麼獲取平台出資的福利",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "您是指定國家的用戶即可，點擊上方報名按鈕，當平台審核完成後將會把{0}USDT轉入當前賬戶下的賞金賬戶，您可劃轉至其他賬戶下進行投資。",
  什么是分红: "什麼是分紅",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "分紅指在規定時間內，收益額到達100%後，可分得超額收益的50%。例如：領取100USDT資金，收益額度是120%。",
  "如何取得分红？": "如何取得分紅？",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "活動週期每{0}天1次，活動結束後進行核算，滿足活動要求後分紅派發至賞金賬戶。若你未達到活動要求，系統將自動清除你的收益額和平台的出資。",
  活动规则: "活動規則",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "參與的賬號需進行KYC認證，每個賬戶僅限一份福利。",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "參與賬號的KYC需要指定的國家方可參與，其他地區無權限參與，請核對活動國家與您的國家是否一致。",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "參與活動成功後，賬戶將臨時鎖定您的提現功能，當完成活動後即可解除您的提現功能。",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "請遵守平台活動規則，若發現作弊、利用系統漏洞進行獲利，平台將會長期凍結您的賬戶下所有資金。",
  平台出资: "平台出資",
  平台出资收回: "平台出資收回",
  投资大师奖励: "投資大師獎勵",
  请下载APP添加收款方式: "請下載APP添加收款方式",
  请下载APP进行身份验证: "請下載APP進行身份驗證",
  请下载APP参与: "請下載APP參與",
  技术指标: "技術指標",
  主图: "主圖",
  副图: "副圖",
  新注册人数: "新註冊人數",
  老用户存款人数: "老用戶存款人數",
  存款人数: "存款人數",
  取款人数: "取款人數",
  投注人数: "投注人數",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "除印度尼西亞、印度、孟加拉國，且未參與過的用戶。",
  市场动态: "市場動態",
  外汇合约: "外匯合約",
  盈亏比: "盈虧比",
  委托价: "委託價",
  可用余额: "可用餘額",
  持仓额: "持倉額",
  强平价: "強勢平價",
  修改: "修改",
  修改价位: "修改價位",
  外汇: "外匯",
  外汇账户: "外匯帳戶",
  我的交易: "我的交易",
  未设置: "未設定",
  超出最大可设数值: "超出最大可設數值",
  超出最小可设数值: "超出最小可設數值",
  止盈超出最小可设数值: "止盈超出最小可設數值",
  止损超出最大可设数值: "停損超出最大可設數值",
  止盈超出最大可设数值: "止盈超出最大可設數值",
  止损超出最小可设数值: "停損超出最小可設數值",
  挖矿: "挖礦",
  交易账户: "交易帳戶",
  买涨: "買漲",
  买跌: "買跌",
  请输入正确的银行卡信息: "請輸入正確的銀行卡信息",
  联系在线客服: "聯絡線上客服",
  法币交易请联系在线客服: "法幣交易請聯絡線上客服",
  提交订单: "提交訂單",
  "支付过程如有疑问,请联系在线客服": "付款過程如有疑問,請聯絡線上客服",
  彩金赠送: "彩金贈送",
  在线客服: "網路客服",
  最少投资: "最少投資",
  "提交时间:": "提交時間:",
  提现拒绝: "提現拒絕",
  认证拒绝: "認證拒絕",
  认证通过: "認證通過",
  请输入正确的交易额度: "請輸入正確的交易額度",
  最大下注金额: "最大下注金額",
  手机号: "手機號",
  邮箱注册: "信箱註冊",
  手机号注册: "手機號碼註冊",
  查询: "查詢",
  手机号登录: "手機號登入",
  邮箱登录: "信箱登入",
  请输入数量: "請輸入數量",
  可用数量: "可用數量",
  钱包登录: "錢包登入",
  请输入正确的邀请码: "請輸入正確的邀請碼",
  "请输入邀请码(必填)": "請輸入邀請碼(必填)",
  输入正确的金额: "輸入正確的金額",
  法币充值: "法幣充值",
  卢比充值: "盧比充值",
  请输入法币: "請輸入法幣",
  请输入IFSC: "請輸入IFSC",
  "银行编码(选填)": "銀行編碼(選填)",
  请输入银行编码: "請輸入銀行編碼",
  请输入大于8位数的密码: "請輸入大於8位數的密碼",
  添加成功: "添加成功",
  "60秒": "60秒",
  "180秒": "180秒",
  "300秒": "300秒",
  "2次密码不一致": "2次答案不一致",
  输入提币数量: "輸入提幣數量",
  图片格式不正确: "圖片格式不正確",
  图片大于20M: "圖片大於20M",
  请设置委托价格: "請設定委託價格",
  输入资金密码: "輸入資金密碼",
  验证码错误: "驗證碼錯誤",
  充值拒绝: "儲值拒絕",
  请输入SSN: "請輸入SSN",
  合约交易: "合約交易",
  结算完成: "結算完成",
  继续下单: "繼續下單",
  最低购买: "最低購買",
  最高购买: "最高購買",
  限价: "限價",
  买入价格: "買入價格",
  买入量: "買入量",
  卖出价格: "賣出價格",
  卖出量: "賣出量",
  买入: "買入",
  卖出: "賣出",
  订单创建成功: "訂單創建成功",
  币币买入支出: "幣幣買入支出",
  币币买入支出退还: "幣幣買入支出退還",
  币币买入获得: "幣幣買入獲得",
  币币卖出支出: "幣幣賣出支出",
  币币卖出支出退还: "幣幣賣出支出退還",
  币币卖出获得: "幣幣賣出獲得",
  币币交易手续费: "幣幣交易手續費",
  请输入限价: "請輸入限價",
  成交: "成交",
  等待成交: "等待成交",
  交易完成: "交易完成",
  被取消: "被取消",
  交易时间: "交易時間",
  法币交易: "法幣交易",
  法币出售: "法幣出售",
  两次密码不一致: "兩次密碼不一致",
  再次输入账户密码: "再次輸入帳戶密碼",

  美国: "美國",
  韩国: "韓國",
  阿尔巴尼亚: "阿爾巴尼亞",
  津巴布韦: "辛巴威",
  赞比亚: "尚比亞",
  也门: "葉門",
  美属维尔京群岛: "美屬維爾京群島",
  英属处女群岛: "英屬處女群島",
  越南: "越南",
  委内瑞拉: "委內瑞拉",
  瓦努阿图: "萬那杜",
  乌兹别克斯坦: "烏茲別克",
  乌拉圭: "烏拉圭",
  英国: "英國",
  阿拉伯联合酋长国: "阿拉伯聯合大公國",
  乌克兰: "烏克蘭",
  乌干达: "烏干達",
  特克斯和凯科斯群岛: "特克斯和凱科斯群島",
  土库曼斯坦: "土庫曼",
  土耳其: "土耳其",
  突尼斯: "突尼西亞",
  特立尼达和多巴哥: "千里達及托巴哥",
  汤加: "東加",
  多哥: "多哥",
  东帝汶: "東帝汶",
  泰国: "泰國",
  坦桑尼亚: "坦尚尼亞",
  塔吉克斯坦: "塔吉克斯坦",
  中国台湾: "中國台灣",
  叙利亚: "敘利亞",
  瑞士: "瑞士",
  瑞典: "瑞典",
  斯威士兰: "史瓦濟蘭",
  苏里南: "蘇利南",
  苏丹: "蘇丹",
  斯里兰卡: "斯里蘭卡",
  西班牙: "西班牙",
  南非: "南非",
  索马里: "索馬利亞",
  所罗门群岛: "索羅門群島",
  斯洛文尼亚: "斯洛維尼亞",
  斯洛伐克: "斯洛伐克",
  "圣马丁岛（荷兰部分）": "聖馬丁島（荷蘭部分）",
  新加坡: "新加坡",
  塞拉利昂: "獅子山",
  塞舌尔: "塞席爾",
  塞尔维亚: "塞爾維亞",
  塞内加尔: "塞內加爾",
  沙特阿拉伯: "沙烏地阿拉伯",
  圣多美和普林西比: "聖多美和普林西比",
  圣马力诺: "聖馬利諾",
  萨摩亚: "薩摩亞",
  圣克里斯托弗和尼维斯: "聖克里斯托弗和尼維斯",
  圣文森特和格林纳丁斯: "聖文森及格瑞那丁",
  圣彼埃尔和密克隆岛: "聖彼埃爾和密克隆島",
  圣露西亚: "聖露西亞",
  圣基茨和尼维斯: "聖克里斯多福及尼維斯",
  卢旺达: "盧安達",
  俄罗斯: "俄羅斯",
  罗马尼亚: "羅馬尼亞",
  留尼汪: "留尼汪",
  刚果共和国: "剛果共和國",
  卡塔尔: "卡達",
  波多黎各: "波多黎各",
  葡萄牙: "葡萄牙",
  波兰: "波蘭",
  菲律宾: "菲律賓",
  秘鲁: "秘魯",
  巴拉圭: "巴拉圭",
  巴布亚新几内亚: "巴布亞紐幾內亞",
  巴拿马: "巴拿馬",
  巴勒斯坦: "巴勒斯坦",
  帕劳: "帛琉",
  巴基斯坦: "巴基斯坦",
  阿曼: "阿曼",
  挪威: "挪威",
  尼日利亚: "奈及利亞",
  尼日尔: "尼日",
  尼加拉瓜: "尼加拉瓜",
  新西兰: "紐西蘭",
  新喀里多尼亚: "新喀裡多尼亞",
  荷属安德列斯群岛: "荷屬安德列斯群島",
  荷兰: "荷蘭",
  尼泊尔: "尼泊爾",
  纳米比亚: "納米比亞",
  缅甸: "緬甸",
  莫桑比克: "莫三比克",
  摩洛哥: "摩洛哥",
  蒙特塞拉特岛: "蒙特塞拉特島",
  黑山: "蒙特內哥羅",
  蒙古: "蒙古",
  摩纳哥: "摩納哥",
  摩尔多瓦: "摩爾多瓦",
  墨西哥: "墨西哥",
  马约特: "馬約特",
  毛里求斯: "模里西斯",
  毛里塔尼亚: "茅利塔尼亞",
  马里亚纳群岛: "馬里亞納群島",
  马提尼克: "馬提尼克",
  马耳他: "馬爾他",
  马里: "馬里",
  马尔代夫: "馬爾地夫",
  马来西亚: "馬來西亞",
  马拉维: "馬拉威",
  马达加斯加: "馬達加斯加",
  马其顿: "馬其頓",
  中国澳门: "中國澳門",
  卢森堡: "盧森堡",
  立陶宛: "立陶宛",
  列支敦士登: "列支敦斯登",
  利比亚: "利比亞",
  利比里亚: "賴比瑞亞",
  莱索托: "賴索托",
  黎巴嫩: "黎巴嫩",
  拉脱维亚: "拉脫維亞",
  老挝: "寮國",
  吉尔吉斯斯坦: "吉爾吉斯斯坦",
  科威特: "科威特",
  基里巴斯: "吉里巴斯",
  肯尼亚: "肯亞",
  哈萨克斯坦: "哈薩克",
  约旦: "約旦",
  日本: "日本",
  牙买加: "牙買加",
  象牙海岸: "象牙海岸",
  意大利: "義大利",
  以色列: "以色列",
  爱尔兰: "愛爾蘭",
  伊拉克: "伊拉克",
  伊朗: "伊朗",
  印度尼西亚: "印度尼西亞",
  印度: "印度",
  冰岛: "冰島",
  匈牙利: "匈牙利",
  中国香港: "中國香港",
  洪都拉斯: "宏都拉斯",
  海地: "海地",
  圭亚那: "蓋亞那",
  几内亚比绍共和国: "幾內亞比紹共和國",
  几内亚: "幾內亞",
  危地马拉: "瓜地馬拉",
  关岛: "關島",
  瓜德罗普岛: "瓜德羅普島",
  格林纳达: "格瑞那達",
  格陵兰岛: "格陵蘭島",
  希腊: "希臘",
  直布罗陀: "直布羅陀",
  加纳: "迦納",
  德国: "德國",
  格鲁吉亚: "格魯吉亞",
  冈比亚: "甘比亞",
  加蓬: "加彭",
  法属波利尼西亚: "法屬波利尼西亞",
  法属圭亚那: "法屬圭亞那",
  法国: "法國",
  芬兰: "芬蘭",
  斐济: "斐濟",
  法罗群岛: "法羅群島",
  埃塞俄比亚: "衣索比亞",
  爱沙尼亚: "愛沙尼亞",
  厄立特里亚: "厄利垂亞",
  赤道几内亚: "赤道幾內亞",
  萨尔瓦多: "薩爾瓦多",
  埃及: "埃及",
  厄瓜多尔: "厄瓜多",
  多米尼加共和国: "多米尼加共和國",
  多米尼加: "多明尼加",
  吉布提: "吉布地",
  丹麦: "丹麥",
  捷克: "捷克",
  塞浦路斯: "賽普勒斯",
  库拉索: "庫拉索",
  古巴: "古巴",
  克罗地亚: "克羅埃西亞",
  哥斯达黎加: "哥斯大黎加",
  科特迪瓦: "科特迪瓦",
  库克群岛: "庫克群島",
  科摩罗: "葛摩",
  哥伦比亚: "哥倫比亞",
  智利: "智利",
  乍得: "查德",
  中非共和国: "中非共和國",
  佛得角: "維德角",
  开曼群岛: "開曼群島",
  开普: "開普",
  加拿大: "加拿大",
  喀麦隆: "喀麥隆",
  柬埔寨: "柬埔寨",
  布隆迪: "蒲隆地",
  布基纳法索: "布吉納法索",
  保加利亚: "保加利亞",
  文莱: "汶萊",
  巴西: "巴西",
  博茨瓦纳: "波札那",
  波斯尼亚和黑塞哥维那: "波士尼亞與赫塞哥維納",
  玻利维亚: "玻利維亞",
  不丹: "不丹",
  百慕大群岛: "百慕大群島",
  贝宁: "貝南",
  伯利兹: "貝里斯",
  比利时: "比利時",
  白俄罗斯: "白俄羅斯",
  巴巴多斯: "巴貝多",
  孟加拉国: "孟加拉國",
  巴林: "巴林",
  巴哈马: "巴哈馬",
  阿塞拜疆: "亞塞拜然",
  奥地利: "奧地利",
  澳大利亚: "澳大利亞",
  阿鲁巴: "阿魯巴",
  亚美尼亚: "亞美尼亞",
  阿根廷: "阿根廷",
  安提瓜和巴布达: "安地卡及巴布達",
  安圭拉: "安圭拉",
  安哥拉: "安哥拉",
  安道尔: "安道爾",
  美属萨摩亚: "美屬薩摩亞",
  阿尔及利亚: "阿爾及利亞",
  中国: "中國",

  日收益: "日收益",
  "30天预期收益": "30天預期收益",
  英伟达高速矿机: "英偉達高速礦機",
  去投资: "去投資",
  新币榜: "新幣榜",
  主题: "主題",
  立即探索: "立即探索",
  等您来: "等您來",
  最新活动: "最新活動",
  货币划转: "貨幣劃轉",
  提现钱包: "提現錢包",
  加密合约: "加密合約",
  外汇期货: "外匯期貨",
  定期: "定期",
  探索产品: "探索產品",
  稳健型: "穩健型",
  高收益: "高收益",
  期货账户: "期貨帳戶",
  时间线: "時間線",
  收藏: "收藏",
  委托订单: "委託訂單",
  最新交易: "最新交易",
  深度图: "深度圖",
  标记价格: "標記價格",
  "24h最高价": "24h最高價",
  "24h成交量": "24h成交量",
  "24h最低价": "24h最低價",
  "24h成交额": "24h成交額",
  "价格(USDT)": "價格(USDT)",
  "数量(ETH)": "數量(ETH)",
  看空: "看空",
  余额不足: "餘額不足",
  最低购买: "最低購買",
  最高购买: "最高購買",
  下单成功: "下單成功",
  平仓成功: "平倉成功",
  请输入正确的平仓数量: "請輸入正確的平倉數量",
  加仓成功: "加倉成功",
  请输入正确的加仓金额: "請輸入正確的加倉金額",
  收藏成功: "收藏成功",
  取消收藏成功: "取消收藏成功",
  日收益率: "日收益率",
  轻松理财: "輕鬆理財",
  立即申购: "立即申購",
  申购日期: "申購日期",
  加密货币: "加密貨幣",
  交割合约: "交割合约",
  最小投资: "最小投資",
  委托: "委託",
  "当指数价格触达时，将会触发委托平仓": "當指數價格觸達時，將會觸發委託平倉",
  预计盈利: "預計盈利",
  最大投资: "最大投資",
  现货交易: "幣幣交易",
  输入交易金额: "輸入交易金額",
  "可用额度：": "可用額度",
  提现货币: "提現貨幣",
  立即申购: "立即申購",
  期货合约: "期貨合約",
  加密币永续: "加密幣永續",
  外汇永续: "外匯永續",
  期权账户: "期權賬戶",
  夜间模式: "夜間模式",
  未结盈亏: "未結盈虧",
  超额收益: "超額收益",
  "安全策略，低买高卖": "安全性原則，低買高賣",
  投资金额应为: "投資金額應為",
  总收益率: "總收益率",
  赎回成功: "贖回成功",
  快捷卖币: "快捷賣幣",
  修改止盈止损: "修改止盈止损",
  白皮书: "白皮書",

  托管资金: "托管資金",
  托管中: "托管中",
  预计日收益: "預計日收益",
  累计收益: "累計收益",
  周期: "週期",
  日收益: "日收益",
  限额: "限額",
  立即托管: "立即託管",
  "已鎖定 請聯繫客服": "已鎖定 請聯繫客服",
  产品列表: "產品列表",
  规则: "規則",
  创建订单: "創建訂單",
  产品名称: "產品名稱",
  托管周期: "託管週期",
  等级限制: "等級限制",
  托管金额: "託管金額",
  限额: "限額",
  余额: "餘額",
  购买日: "購買日",
  起息日: "起息日",
  派息时间: "派息時間",
  每天: "每天",
  计息结束日: "計息結束日",
  每日收益: "每日收益",
  预计收益: "預計收益",
  "收益将自动发送至您的余额账户;": "收益將自動發送至您的餘額帳戶;",
  "您的资金没有任何风险;": "您的資金沒有任何風險;",
  "365*24小时不断地工作;": "365*24小時不斷地工作;",
  托管中: "托管中",
  结束: "結束",
  今日收益: "今日收益",
  剩余周期: "剩餘週期",
  进行中: "進行中",
  已发放: "已發放",
  信誉分: "信譽分",

  复制成功: "複製成功",
  VIP权益: "VIP權益",
  旧密码: "舊密碼",
  请输入旧密码: "請輸入舊密碼",
  "忘记旧密码请联系客服重置。": "忘記舊密碼請聯繫客服重置。",
  去升级: "去升級",
  描述: "描述",
  实际存款金额: "實際存款金額",
  升级礼金: "升級禮金",
  隔夜利息: "隔夜利息",
  自动结算: "自動結算",
  等级规则: "等級規則",
  "WEB3.0币持有数据收益": "WEB3.0幣持有數據收益",
  总生产: "總生產",
  有效节点: "有效節點",
  参与人: "參與人",
  用户收益: "用戶收益",
  "流动性WEB3.0输出": "流動性WEB3.0輸出",
  总资产: "總資產",

  ETHAI持有数据收益: "ETHAI持有數據收益",
  AI量化流动性: "AI量化流動性",
  现货买入手续费: "現貨買入手續費",
  现货支出: "現貨支出",
  现货资金费率: "現貨資金費率",
  现货卖出手续费: "現貨賣出手續費",
  现货收入: "現貨收入",
  外汇合约支出: "外匯合約支出",
  外汇合约买入手续费: "外匯合約買入手續費",
  外汇合约资金费率: "外匯合約資金費率",
  外汇合约卖出手续费: "外匯合約賣出手續費",
  外汇合约收入: "外匯合約收入",
  理财购买: "理財購買",
  VIP理财日收益: "VIP理財日收益",
  VIP理财隔夜利息: "VIP理財隔夜利息",
  VIP本金返还: "VIP本金返還",
  VIP彩金发放: "VIP彩金發放",
  VIP彩金抵扣: "VIP彩金抵扣",
  隔夜利息: "隔夜利息",
  设置资产密码: "設置資產密碼",
  "AI Quant": "AI 量化",

  锁仓挖矿: "鎖倉挖礦",
  一站式理财服务: "一站式理財服務",
  产品: "產品",
  客服中心: "客服中心",
  贷款: "貸款",
  挖矿赚不停: "挖礦賺不停",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "鎖倉挖礦是通過將USDT (USD:1USDT=1USD) 託管給平台超算力礦機，在平台礦池中進行挖礦收益。",
  产品优势: "產品優勢",
  随存随取: "隨存隨取",
  锁仓周期: "鎖倉週期",
  每日下发: "每日下發",
  随机空投: "隨機空投",
  "100%资金安全保障": "100%資金安全保障",
  "100%节假日收益不间断": "100%節假日收益不間斷",
  成功锁仓后当天产出: "成功鎖倉後當天產出",
  关于违约金: "關於違約金",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "若您希望轉出未到期的本金,則會產生違約金,違約金=違約結算比例*剩餘天數*鎖倉金額.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "舉例:此鎖倉挖礦的違約結算比例為5%,剩餘3天到期,鎖倉金額為10000U《USDT/USD》,則違約金=5%*3*10000=1500U,實際退回本金為15000U-1500U",
  收益计算: "收益計算",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "平台有多種鎖倉挖礦理財產品供使用者選擇,收益計算如下,舉例:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "會員在平台鎖倉10000U(USDT,USD),如選擇了週期為7天,日產出為鎖倉金額的0.7%~1.8%的理財產品,則每天產出如下",
  "最低:10000Ux0.7%=70U;": "最低:10000Ux0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "最高:10000Ux1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "即7天後可獲得490U~1260U的收益,收益每日下發,鎖倉本金到期後,自動轉入您的資金賬戶.",
  正在托管的资金: "正在託管的資金",
  签到: "簽到",
  锁仓订单: "鎖倉訂單",
  预计今日收益: "預計今日收益",
  累计收益: "累計收益",
  托管中的订单: "託管中的訂單",
  单笔最少: "單筆最少",
  单笔最多: "單筆最多",
  日收益率: "日收益率",
  说明: "說明",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1.數據統計時間以GMT+8時間為準<br>2.每日收益值以GMT+8當天時間00:00-23:59點(本地時間00:00-23:59)的所有已結算訂單為基準計算得出<br>3.當天的收益會統一在次日GMT+8時間00:00-00:10內派發.",
  知道了: "知道了",
  锁仓: "鎖倉",
  派息时间: "派息時間",
  每日: "每日",
  托管资金: "託管資金",
  到期返回: "到期返回",
  提前赎回: "提前贖回",
  预计收益: "預計收益",
  认购: "認購",
  热门: "熱門",
  数字货币: "數字貨幣",
  贵金属: "貴金屬",
  大宗商品: "大宗商品",
  持仓明细: "持倉明細",
  历史明细: "歷史明細",
  当前价: "當前價",
  "↑买涨": "↑買漲",
  "↓买跌": "↓買跌",
  显示全部: "顯示全部",
  买入金额: "買入金額",
  方向: "方向",
  收益: "收益",
  预期收益: "預期收益",
  估用保证金: "估用保證金",
  确认下单: "確認下單",
  锁定: "鎖定",
  账户总资产: "賬戶總資產",
  明细: "明細",
  今日收益: "今日收益",
  仓位保证金: "倉位保證金",
  持有仓位: "持有倉位",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "鎖定金額=所有鎖倉挖礦中未完成訂單的金額總和",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1.數據統計時間以GMT+8時間為準<br>2.每日收益值以GMT+8當天時間00:00-23:59點(本地時間00:00-23:59)的所有已結算訂單為基準計算得出",
  充值方式: "充值方式",
  银行汇款: "銀行匯款",
  "银行汇款请联系客服进行操作!": "銀行匯款請聯繫客服進行操作!",
  提款方式: "提款方式",
  "银行提款请联系客服进行操作!": "銀行提款請聯繫客服進行操作!",
  资金明细: "資金明細",
  提现记录: "提現記錄",
  拒绝: "拒絕",
  通过: "通過",
  拒绝原因: "拒絕原因",

  消息公告: "消息公告",
  订单: "訂單",
  个人中心: "個人中心",
  "未到期赎回需支付一定的违约金!": "未到期贖回需支付一定的違約金!",

  请输入区号: "請輸入區號",
  "请选择国家/地区": "請選擇國家/地區",

  今日开盘: "今日開盤",
  昨日收盘: "昨日收盤",

  实名认证即送: "實名認證即送",
  立即认证: "立即認證",
  新用户礼包: "新用戶禮包",
  完成新人任务领取: "完成新手任務領取",
  认证: "認證",
  时间周期: "時間週期",
  支付金额: "支付金額",
  已平仓: "已平倉",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX 新用戶歡迎禮包：每位用戶最多可獲得",
  我已经阅读并同意: "我已經閱讀並同意",
  隐私政策: "隱私政策",
  放弃奖励离开: "放棄獎勵離開",
  继续注册: "繼續註冊",
  分钟: "分鐘",

  "请先勾选隐私政策!": "請先勾選隱私權政策!",
  添加其他到自选: "新增其他到自選",
  充值最高可得: "儲值最高可得$30,000",

  请输入格式正确的手机号: "請輸入格式正確的手機號",

  收起: "收起",
  上传截图: "上傳截圖",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*充值成功後必須上傳充值截圖，否則將視為無效存款。",
};



// WEBPACK FOOTER //
// ./src/lang/zh-hk.js